import { logger } from 'logging-utils';
import apiKeySettingsService from '../services';
import {
  removeApiKey,
  updateApiKey,
} from '../store-actions/api-keys-store-actions';
import {
  clearErrorMessage,
  closeDeleteApiKeyModal,
  closeSetApiKeyExpirationModal,
  closeSetApiKeyStatusModal,
  setErrorMessage,
  setLoadingDeleteApiKey,
  setLoadingSetApiKeyExpiration,
  setLoadingSetApiKeyStatus,
} from '../store-actions/update-api-key-store-actions';
import {
  ApiKey,
  ApiKeyError,
  DeleteApiKeyInput,
  SetApiKeyExpirationInput,
  SetApiKeyStatusInput,
} from '../types/api-key-types';
import { apiKeyStatusToSetMap } from '../utils/api-key-utils';

export const deleteApiKey = async (id: string) => {
  try {
    setLoadingDeleteApiKey(true);
    clearErrorMessage();

    const deleteApiKeyInput: DeleteApiKeyInput = {
      id,
    };

    const deleteApiKeyRes = await apiKeySettingsService.deleteApiKey.execute(
      deleteApiKeyInput,
    );

    if (!deleteApiKeyRes) {
      setErrorMessage(ApiKeyError.FailedDeleteApiKeys);
      return;
    }

    removeApiKey(id);
  } catch (error) {
    logger.error('Failed to delete api key', error);
  } finally {
    setLoadingDeleteApiKey(false);
    closeDeleteApiKeyModal();
  }
};

export const setApiKeyStatus = async (apiKey: ApiKey) => {
  try {
    setLoadingSetApiKeyStatus(true);
    clearErrorMessage();

    const setApiKeyStatusInput: SetApiKeyStatusInput = {
      id: apiKey.id,
      apiKeyStatus: apiKeyStatusToSetMap[apiKey.apiKeyStatus],
    };

    const setApiKeyStatusRes =
      await apiKeySettingsService.setApiKeyStatus.execute(setApiKeyStatusInput);

    if (!setApiKeyStatusRes) {
      setErrorMessage(ApiKeyError.FailedSetApiKeyStatus);
      return;
    }

    updateApiKey(setApiKeyStatusRes);
  } catch (error) {
    logger.error('Failed to set api key status', error);
  } finally {
    setLoadingSetApiKeyStatus(false);
    closeSetApiKeyStatusModal();
  }
};

export const setApiKeyExpiration = async (input: SetApiKeyExpirationInput) => {
  try {
    setLoadingSetApiKeyExpiration(true);
    clearErrorMessage();

    const setApiKeyExpirationRes =
      await apiKeySettingsService.setApiKeyExpiration.execute(input);

    if (!setApiKeyExpirationRes) {
      setErrorMessage(ApiKeyError.FailedSetApiKeyExpiration);
      return;
    }

    updateApiKey(setApiKeyExpirationRes);
  } catch (error) {
    logger.error('Failed to set api key expiration', error);
  } finally {
    setLoadingSetApiKeyExpiration(false);
    closeSetApiKeyExpirationModal();
  }
};
